import { useState, useEffect, useRef } from "react";
import "./Coverflow_Slider.css";

const cards = [
  {
    id: 1,
    title: "DATA NEXUS",
    description: "Big data processing at petabytes of scale with real-time visualization and analytics.",
    tags: ["HADOOP", "SPARK", "KAFKA"],
    image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=600&q=80",
  },
  {
    id: 2,
    title: "AR INTERFACE",
    description: "Augmented reality platform for immersive data visualization and interaction.",
    tags: ["UNITY", "ARKit", "WebXR"],
    image: "https://images.unsplash.com/photo-1593508512255-86ab42a8e620?w=600&q=80",
  },
  {
    id: 3,
    title: "IOT MATRIX",
    description: "Intelligent IoT ecosystem connecting millions of devices with edge computing capabilities.",
    tags: ["MQTT", "EDGE AI", "5G"],
    image: "https://images.unsplash.com/photo-1518770660439-4636190af475?w=600&q=80",
  },
  {
    id: 4,
    title: "NEURAL NETWORK",
    description: "Advanced AI system with deep learning capabilities for predictive analytics and pattern recognition.",
    tags: ["TENSORFLOW", "PYTHON", "CUDA"],
    image: "https://images.unsplash.com/photo-1485827404703-89b55fcc595e?w=600&q=80",
  },
  {
    id: 5,
    title: "QUANTUM CLOUD",
    description: "Next-generation cloud infrastructure leveraging quantum computing for unprecedented processing power.",
    tags: ["AWS", "KUBERNETES", "DOCKER"],
    image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=600&q=80",
  },
  {
    id: 6,
    title: "BLOCKCHAIN VAULT",
    description: "Decentralized security architecture using advanced cryptographic protocols.",
    tags: ["WEB3", "SOLIDITY", "IPFS"],
    image: "https://images.unsplash.com/photo-1639762681485-074b7f938ba0?w=600&q=80",
  },
  {
    id: 7,
    title: "CYBER DEFENSE",
    description: "AI-powered cybersecurity platform with real-time threat detection and response.",
    tags: ["ZERO-TRUST", "SIEM", "SOC"],
    image: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=600&q=80",
  },
];

 function Coverflow_Slider() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const autoPlayRef = useRef(null);
  const total = cards.length;

  const startAutoPlay = () => {
    autoPlayRef.current = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % total);
    }, 2000);
  };

  const stopAutoPlay = () => {
    clearInterval(autoPlayRef.current);
  };

  useEffect(() => {
    if (!isHovered) startAutoPlay();
    return stopAutoPlay;
  }, [isHovered]);

  const goTo = (index) => {
    stopAutoPlay();
    setActiveIndex((index + total) % total);
    if (!isHovered) startAutoPlay();
  };

  const getCardStyle = (index) => {
    let diff = index - activeIndex;
    if (diff > total / 2) diff -= total;
    if (diff < -total / 2) diff += total;

    const absD = Math.abs(diff);
    const sign = Math.sign(diff);

    if (absD > 3) return { display: "none" };

    const rotateY = diff * 45;
    const translateX = diff * 290;
    const translateZ = absD === 0 ? 0 : -absD * 80;
    // const scale = absD === 0 ? 1 : absD === 1 ? 0.82 : absD === 2 ? 0.66 : 0.52;
    const scale = absD === 0 ? 1 : absD === 1 ? 0.88 : absD === 2 ? 0.72 : 0.55;
    const opacity = absD === 0 ? 1 : absD === 1 ? 0.85 : absD === 2 ? 0.6 : 0.35;
    const zIndex = 100 - absD * 10;
    const brightness = absD === 0 ? 1 : absD === 1 ? 0.7 : absD === 2 ? 0.45 : 0.25;

    return {
      transform: `translateX(${translateX}px) translateZ(${translateZ}px) rotateY(${rotateY}deg) scale(${scale})`,
      opacity,
      zIndex,
      filter: `brightness(${brightness})`,
    };
  };

  return (
    <div className="slider-root">
      <div className="slider-bg" />

      <div
        className="slider-scene"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div className="slider-stage">
          {cards.map((card, i) => {
            const style = getCardStyle(i);
            if (style.display === "none") return null;
            const isActive = i === activeIndex;

            return (
              <div
                key={card.id}
                className={`slider-card${isActive ? " active" : ""}`}
                style={style}
                onClick={() => goTo(i)}
              >
                <div className="card-img-wrap">
                  <img src={card.image} alt={card.title} />
                  <div className="card-img-overlay" />
                </div>

                <div className="card-body">
                  <h2 className="card-title">{card.title}</h2>
                  <p className="card-desc">{card.description}</p>
                  <div className="card-tags">
                    {card.tags.map((t) => (
                      <span key={t} className="tag">{t}</span>
                    ))}
                  </div>
                  <button className="card-btn">EXPLORE</button>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="slider-dots">
        {cards.map((_, i) => (
          <button
            key={i}
            className={`dot${i === activeIndex ? " active" : ""}`}
            onClick={() => goTo(i)}
          />
        ))}
      </div>

      <button className="nav-btn prev" onClick={() => goTo(activeIndex - 1)}>&#8249;</button>
      <button className="nav-btn next" onClick={() => goTo(activeIndex + 1)}>&#8250;</button>
    </div>
  );
}
export default Coverflow_Slider;